var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0388 1.34928C9.31589 0.383753 10.6841 0.383751 10.9612 1.34928L12.459 6.56834C12.5856 7.00948 12.9962 7.30781 13.4549 7.29189L18.8813 7.10361C19.8853 7.06878 20.3081 8.37002 19.4754 8.93192L14.9746 11.9692C14.5942 12.2259 14.4374 12.7086 14.5942 13.1399L16.4502 18.2426C16.7935 19.1866 15.6866 19.9908 14.8949 19.3726L10.6155 16.0306C10.2538 15.7482 9.74622 15.7482 9.38451 16.0306L5.10508 19.3726C4.31338 19.9908 3.20647 19.1866 3.54982 18.2426L5.40576 13.1399C5.56263 12.7086 5.40579 12.2259 5.02537 11.9692L0.524597 8.93192C-0.308051 8.37002 0.114749 7.06878 1.11865 7.10361L6.54512 7.29189C7.00378 7.30781 7.4144 7.00948 7.541 6.56835L9.0388 1.34928Z",
    fill: "#eaeaeb"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtStar);
export default __webpack_public_path__ + "static/media/ft-star.f89b2570217307833f3ecacc2de3b98f.svg";
export { ForwardRef as ReactComponent };